// :cow: Cosmose CONFIDENTIAL :iso:
export enum PlannerFullDemoStepEnum {
  campaignListAddNewCampaign = 'china-campaignListAddNewCampaign',
  campaignObjectiveSelectNewStoreOpening = 'china-campaignObjectiveSelectNewStoreOpening',
  plannerStartSelectAudience = 'china-plannerStartSelectAudience',
  audienceShowEstimates = 'china-audienceShowEstimates',
  audienceReadSegmentDescriptions = 'china-audienceReadSegmentDescriptions',
  audienceSelectCompetitors = 'china-audienceSelectCompetitors',
  audienceShowEstimatesChange = 'china-audienceShowEstimatesChange',
  audienceSelectLocationCategories = 'china-audienceSelectLocationCategories',
  audienceExplainAddingLocationCategories = 'china-audienceExplainAddingLocationCategories',
  audienceAskToSelectCity = 'china-audienceAskToSelectCity',
  audienceShowTimespan = 'china-audienceShowTimespan',
  audienceAskToClickContinue = 'china-audienceAskToClickContinue',
  demographicsSelectGender = 'china-demographicsSelectGender',
  demographicsAskToClickContinue = 'china-demographicsAskToClickContinue',
  budgetSelectCampaignDuration = 'china-budgetSelectCampaignDuration',
  budgetCalculationExplanation = 'china-budgetCalculationExplanation',
  budgetAskToClickContinue = 'china-budgetAskToClickContinue',
  mediaSearchPlatform = 'china-mediaSearchPlatform',
  mediaSelectFormat = 'china-mediaSelectFormat',
  mediaAskToClickContinue = 'china-mediaAskToClickContinue',
  spotplanAnalyze = 'china-spotplanAnalyze',
  spotplanAskToClickSummary = 'china-spotplanAskToClickSummary',
  summaryAskToClickSendForReview = 'china-summaryAskToClickSendForReview',
  sentForReviewAskToClickBackToDashboard = 'china-sentForReviewAskToClickBackToDashboard',
  campaignListExposeCampaign = 'china-campaignListExposeCampaign',
}
